import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { kmsDecrypt, kmsEncrypt, base64ToArrayBuffer } from '@/utils/kmsＭethod'
import { getIpToken } from '@/api/toB'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGEING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
}

let deviceId = ''

export async function getBorrowToken (clientId, type) {
  const visitorId = await initFingerprintJS()
  // console.log(visitorId)
  const verificationParams = {
    deviceId: visitorId,
    client_id: clientId,
    type: type
  }
  const encoded = JSON.stringify(verificationParams)

  const blob = await kmsEncrypt(encoded)
  // console.log(blob)

  const b64encoded = btoa(String.fromCharCode.apply(null, blob))
  // console.log(b64encoded)
  const payload = {
    'kms-data': b64encoded
  }

  return new Promise((resolve, reject) => {
    getIpToken(payload)
      .then((res) => {
        // console.log(res)
        const uint8View = new Uint8Array(base64ToArrayBuffer(res.data))
        const audioParams = {
          CiphertextBlob: uint8View
        }
        return kmsDecrypt(audioParams)
      })
      .then((uint8array) => {
        const lambdaToken = String.fromCharCode(...uint8array)
        // console.log(lambdaToken)
        return firebaseAuthLogin(clientId, deviceId, lambdaToken)
      })
      .then((idToken) => {
        // console.log(idToken)
        return kmsEncrypt(idToken)
      })
      .then(blob => {
        // console.log(blob)
        const credentialToken = btoa(String.fromCharCode.apply(null, blob))
        // return credentialToken
        console.log('log!!:' + credentialToken)
        resolve(credentialToken)
      })
      .catch((err) => {
        console.log(`tokenfail:${err}`)
        reject(err.response)
      })
  })
}

async function initFingerprintJS () {
  const fpPromise = FingerprintJS.load()

  const fp = await fpPromise
  const result = await fp.get()
  deviceId = result.visitorId
  return result.visitorId
}

async function firebaseAuthLogin (businessId, userId, idToken) {
  // firebase.auth().onAuthStateChanged(function (user) {
  //   if (user) {
  //     user.getIdToken(true)
  //       .then(function (idToken) {
  //         console.log(idToken)
  //         formatFirebaseToken(idToken)
  //         return idToken
  //       })
  //   }
  // })
  if (firebase.apps.length === 0) {
    console.log('1. firebase init')
    firebase.initializeApp(firebaseConfig, '2b_' + businessId)
  }
  return new Promise((resolve, reject) => {
    firebase.auth().signInWithCustomToken(idToken)
      .then(userCredential => {
        // console.log(userCredential)
        const user = userCredential.user.getIdToken(true)
        resolve(user)
      })
      .catch(function (error) {
        var errorMessage = error.message
        reject(errorMessage)
      })
  })
}

export async function getCurrentUserAuthorization (id) {
  if (firebase.apps.length === 0) {
    console.log('1. firebase init')
    firebase.initializeApp(firebaseConfig, '2b_' + id)
  }

  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        user.getIdToken(true)
          .then(function (idToken) {
            return kmsEncrypt(idToken)
          })
          .then(blob => {
            const credentialToken = btoa(String.fromCharCode.apply(null, blob))
            // console.log('log!!:' + credentialToken)
            resolve(credentialToken)
          })
          .catch(function (error) {
            var errorMessage = error.message
            reject(errorMessage)
          })
      } else {
        resolve('')
      }
    })
  })
  // const currentUser = firebase.auth().currentUser
  // if (currentUser) {
  //   const token = await currentUser.getIdToken()
  //   const blob = await kmsEncrypt(token)
  //   const credentialToken = btoa(String.fromCharCode.apply(null, blob))
  //   console.log(credentialToken)
  //   return credentialToken
  // } else {
  //   return ''
  // }
}



// WEBPACK FOOTER //
// ./src/utils/get_toB_token.js